import { render, staticRenderFns } from "./AddKanbanfunnel.vue?vue&type=template&id=560881d8&scoped=true&"
import script from "./AddKanbanfunnel.vue?vue&type=script&lang=js&"
export * from "./AddKanbanfunnel.vue?vue&type=script&lang=js&"
import style0 from "./AddKanbanfunnel.vue?vue&type=style&index=0&id=560881d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560881d8",
  null
  
)

export default component.exports